import { ComponentProps, ReactNode } from 'react';
import classNames from 'classnames';
import Radio from '../Radio';
import InputField from '../InputField';
import CheckboxRadioLabel from '../CheckboxRadioLabel/CheckboxRadioLabel';
import { Size } from '../../types';
import styles from '../CheckboxGroup/CheckboxGroup.module.scss';

type Props = {
  className?: string;
  disabled?: boolean;
  errorText?: ComponentProps<typeof InputField>['errorText'];
  helperText?: ComponentProps<typeof InputField>['helperText'];
  labelText?: ComponentProps<typeof InputField>['labelText'];
  labelTextVariant?: ComponentProps<typeof InputField>['labelTextVariant'];
  name: string;
  onChange: (value: string) => void;
  options: {
    disabled?: ComponentProps<typeof Radio>['disabled'];
    selected: ComponentProps<typeof Radio>['selected'];
    subtext?: ReactNode;
    testId: string;
    text: ReactNode;
    value: string;
  }[];
  radioClassName?: string;
  size?: Size<'sm' | 'md'>;
  testId?: ComponentProps<typeof InputField>['testId'];
  verticalAlignment?: 'center' | 'top';
};

const RadioGroup = ({
  className,
  disabled,
  errorText,
  helperText,
  labelText,
  labelTextVariant,
  name,
  onChange,
  options,
  radioClassName,
  size = 'md',
  testId,
  verticalAlignment
}: Props) => {
  // TODO add optional <fieldset> instead for accessibility

  return (
    <InputField
      className={classNames(styles.container, className)}
      disabled={disabled}
      errorText={errorText}
      helperText={helperText}
      labelText={labelText}
      labelTextVariant={labelTextVariant}
      role="radiogroup"
      testId={testId}
      useDivInsteadOfLabel
    >
      {options.map(option => {
        const { subtext, text, disabled: optionDisabled, testId: optionTestId, selected, value } = option;

        return (
          <Radio
            key={value}
            className={radioClassName}
            disabled={disabled || optionDisabled}
            labelElement={<CheckboxRadioLabel text={text} subtext={subtext} size={size} disabled={disabled || optionDisabled} />}
            name={name}
            onChange={onChange}
            selected={selected}
            size={size}
            testId={optionTestId}
            value={value}
            verticalAlignment={verticalAlignment}
          />
        );
      })}
    </InputField>
  );
};

export default RadioGroup;
